import { queryOptions, useQuery } from "@tanstack/vue-query";
import { api, unwrap } from "./client";
import type { AiBudgetStatus, Me, ToolCallResult, ToolInfo } from "./contracts";

export const meQuery = queryOptions({
  queryKey: ["me"] as const,
  queryFn: () => unwrap(api.GET("/api/v2/me")) as Promise<Me>,
  staleTime: 60_000,
  retry: false,
});

export function useMe() {
  return useQuery(meQuery);
}

export const toolsQuery = queryOptions({
  queryKey: ["me", "tools"] as const,
  queryFn: async () => ((await unwrap(api.GET("/api/v2/me/tools"))).tools as unknown as ToolInfo[]) ?? [],
  staleTime: 5 * 60_000,
});

export function useMyTools() {
  return useQuery(toolsQuery);
}

export function callTool(name: string, args: Record<string, unknown>): Promise<ToolCallResult> {
  return unwrap(api.POST("/api/v2/tools/{name}/call", { params: { path: { name } }, body: { arguments: args } }));
}

export function breakGlass(body: { roleId?: string; minutes: number; reason: string }) {
  return unwrap(api.POST("/api/v2/me/breakglass", { body: { roleId: body.roleId ?? "breakglass", minutes: body.minutes, reason: body.reason } }));
}

/** Your AI budget: the policies that apply to you, spend and what remains. */
export function useMyAiBudget() {
  return useQuery({
    queryKey: ["me", "ai-budget"] as const,
    queryFn: () => unwrap(api.GET("/api/v2/me/ai-budget")) as Promise<AiBudgetStatus>,
    staleTime: 60_000,
    retry: false,
  });
}
